import {
  BACCARAT_IDS,
  BLACKJACK_AMERICAN_ID,
  BLACKJACK_ID,
  BLACKJACK_IDS,
  BLACKJACK_SALON_PRIVE_ID,
  BLACKJACK_UNLIMITED_ID,
  BLACKJACK_VIDEOCHAT_ID,
  KENO_ID,
  KENO_OMSBS_ID,
  LOTTERY_ID,
  LOTTERY_OMSBS_ID,
  ROULETTE_IDS,
  SICBO_IDS,
} from '@ezugi/constants';

export function isBlackjack(gameId) {
  return BLACKJACK_IDS.includes(Number(gameId));
}

export function isUnlimitedBJ(gameId) {
  return Number(gameId) === BLACKJACK_UNLIMITED_ID;
}

export function isBJSalonPrive(gameId) {
  return Number(gameId) === BLACKJACK_SALON_PRIVE_ID;
}

export function isBlackjackVideoChat(gameId) {
  return Number(gameId) === BLACKJACK_VIDEOCHAT_ID;
}

export function isBJNormalSeats(gameId) {
  return [ BLACKJACK_ID, BLACKJACK_AMERICAN_ID, BLACKJACK_VIDEOCHAT_ID ].includes(
    Number(gameId)
  );
}

export function isBaccarat(gameId) {
  return BACCARAT_IDS.includes(Number(gameId));
}

export function isRoulette(gameId) {
  return ROULETTE_IDS.includes(Number(gameId));
}

export function isSicbo(gameId) {
  return SICBO_IDS.includes(Number(gameId));
}

export function isLotteryGame(gameId) {
  return [ LOTTERY_ID, KENO_ID, LOTTERY_OMSBS_ID, KENO_OMSBS_ID ].includes(
    Number(gameId)
  );
}
